/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import Container from "@mui/material/Container";
import _ from "lodash";
import useAuth from "../hooks/useAuth";
import { jwtDecode } from "jwt-decode";
import api from "../config/api";
import { useParams } from "react-router-dom";

// function Copyright() {
//   return (
//     <Typography variant="body2" color="textSecondary" align="center">
//       {"Copyright © "}
//       <Link color="inherit" href="https://material-ui.com/">
//         Your Website
//       </Link>{" "}
//       {new Date().getFullYear()}
//       {"."}
//     </Typography>
//   );
// }

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const formInit = {
  username: "",
  password: "",
  newPassword: "",
};

export default function ChangePassword() {
  const classes = useStyles();
  const auth = useAuth();
  const { token } = useParams();
  const [form, setForm] = useState(_.cloneDeep(formInit));
  const handleChange = ({ target }) => {
    setError(undefined);
    const name = target.name;
    const value = target.value;
    setForm({ ...form, [name]: value });
  };
  const [error, setError] = useState();
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (form.password?.length < 6) {
      return setError(`Password should be greater than 6 characters`);
    }
    if (form.password !== form.newPassword) {
      return setError(`Passwords doesn't match`);
    }
    const res = await auth.changePassword({
      _id: form._id,
      password: form.password,
    });
    console.log(res.data);
  };

  useEffect(() => {
    (async () => {
      const user = await api.post("auth/findByToken", jwtDecode(token));
      if (user.status === 400) {
        return setError(user.data);
      }
      if (user.ok) {
        if (!user.data) {
          setForm(undefined);
        } else {
          setForm(jwtDecode(token));
        }
      }
    })();
  }, []);

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Avatar className={classes.avatar}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          Change Password
        </Typography>
        <form className={classes.form} noValidate onSubmit={handleSubmit}>
          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            label={form.username}
            id="email"
            name="username"
            autoFocus
            onKeyUp={handleChange}
            disabled
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="New Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onKeyUp={handleChange}
          />

          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="newPassword"
            label="Retype New Password"
            type="password"
            id="password"
            autoComplete="current-password"
            onKeyUp={handleChange}
          />

          {error && (
            <Typography
              component="p"
              variant="p"
              style={{ cursor: "pointer", color: "tomato" }}
              color="danger"
            >
              {error}
            </Typography>
          )}

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            Reset Password
          </Button>
          {/* <Grid container>
            <Grid item xs>
              <Link href="#" variant="body2">
                Forgot password?
              </Link>
            </Grid>
            <Grid item>
              <Link href="#" variant="body2">
                {"Don't have an account? Sign Up"}
              </Link>
            </Grid>
          </Grid> */}
        </form>
      </div>
      <Box mt={8}>{/* <Copyright /> */}</Box>
    </Container>
  );
}
